/**
 * Plan tier helpers — mirrors /app/backend/plans.py.
 *
 * Tiers:
 *  - trial      : 7-day free, basic features only
 *  - starter    : $29.99/mo — same features as trial (post-trial billing)
 *  - premium    : $79.99/mo — all features unlocked
 *  - enterprise : custom — all features + bespoke onboarding
 *  - paid       : legacy alias, treated as premium for backward compat
 */

export const PRICING_STARTER = 29.99;
export const PRICING_PREMIUM = 79.99;

const PREMIUM_TIERS = new Set(["premium", "enterprise", "paid"]);

export function isPremium(user) {
  if (!user) return false;
  return PREMIUM_TIERS.has(user.plan);
}

export function planLabel(plan) {
  return {
    trial: "Free Trial",
    starter: "Starter",
    premium: "Premium",
    enterprise: "Enterprise",
    paid: "Premium",         // legacy users see "Premium" label, not "Paid"
  }[plan] || plan;
}
